import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Layout, Menu, Icon, Row, Col } from 'antd'
// import { Bar } from 'ant-design-pro/lib/Charts'

const salesData = [];
for (let i = 0; i < 12; i += 1) {
  salesData.push({
    x: `${i + 1}`,
    y: Math.floor(Math.random() * 1000) + 200,
  })
}


const propTypes = {

}

export class Statistics extends Component {
  constructor(props) {
    super()
  }
  render() {
    return (
      <div className='statistics'>
        <h1>Statistics</h1>
        {/*<Bar*/}
          {/*height={200}*/}
          {/*title="test"*/}
          {/*data={salesData}*/}
        {/*/>*/}
      </div>
      )
  }
}

Statistics.propTypes = propTypes
export default Statistics



// WEBPACK FOOTER //
// ./src/containers/statistics/Statistics.js